import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M3 3h18v2H3z" />, 'Maximize');
